import { render, staticRenderFns } from "./ListConnections.vue?vue&type=template&id=a2187a46"
import script from "./ListConnections.vue?vue&type=script&lang=js"
export * from "./ListConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports